import { render, staticRenderFns } from "./minhas-solicitacoes-cadastro-anos-anteriores.vue?vue&type=template&id=c27bb4a6&scoped=true&"
import script from "./minhas-solicitacoes-cadastro-anos-anteriores.vue?vue&type=script&lang=js&"
export * from "./minhas-solicitacoes-cadastro-anos-anteriores.vue?vue&type=script&lang=js&"
import style0 from "./minhas-solicitacoes-cadastro-anos-anteriores.vue?vue&type=style&index=0&id=c27bb4a6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c27bb4a6",
  null
  
)

export default component.exports